import { render, staticRenderFns } from "./JournalistPager.vue?vue&type=template&id=bdcc5d18&"
import script from "./JournalistPager.vue?vue&type=script&lang=js&"
export * from "./JournalistPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcc5d18')) {
      api.createRecord('bdcc5d18', component.options)
    } else {
      api.reload('bdcc5d18', component.options)
    }
    module.hot.accept("./JournalistPager.vue?vue&type=template&id=bdcc5d18&", function () {
      api.rerender('bdcc5d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/journalist-pager/JournalistPager.vue"
export default component.exports